export default {"src":"/_next/static/media/like-grey-inline.35f2d201.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};